export class ReCaptchaOption {
    projectId: string;
    isEnabled: boolean;
    siteKey: string;
}